import { HomeOutlined, ShopOutlined } from "@ant-design/icons";
import { ADMIN_PREFIX_PATH } from "configs/AppConfig";

// Dedicated side navigation for SUPER_ADMIN role.
// Rendered only when localStorage role is SUPER_ADMIN (see MenuContent).
const superAdminNavTree = [
  {
    key: "manage-koperasi",
    title: "MANAGE KOPERASI",
    breadcrumb: false,
    submenu: [
      {
        key: "super-dashboard",
        path: `${ADMIN_PREFIX_PATH}/super/dashboard`,
        title: "Dashboard",
        icon: HomeOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "daftar-koperasi",
        path: `${ADMIN_PREFIX_PATH}/koperasi`,
        title: "Daftar Perusahaan Koperasi",
        icon: ShopOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const navigationSuperAdminConfig = [...superAdminNavTree];

export default navigationSuperAdminConfig;
